/** Segments d’URL réservés — ne pas interpréter comme `workoutId` sur /workouts/:id/... */
export const WORKOUTS_DYNAMIC_ID_RESERVED = new Set(["sessions", "exercises", "programs", "new"]);

export function isReservedWorkoutsDynamicId(id) {
  return Boolean(id && WORKOUTS_DYNAMIC_ID_RESERVED.has(String(id)));
}
